import React from 'react';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';

const MessageInput = ({ value, onChange, onSend, onEmojiToggle }) => {
  return (
    <TextField
      fullWidth
      label="Message"
      value={value}
      onChange={e => onChange(e.target.value)}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onSend();
        }
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {onEmojiToggle && (
              <IconButton onClick={onEmojiToggle} tabIndex={-1}>
                <InsertEmoticonIcon />
              </IconButton>
            )}
            <IconButton onClick={onSend} disabled={!value.trim()}>
              <SendIcon />
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
};

export default MessageInput;
